/**
 * @module @anydo/auth
 */

export {
  AUTH_APPLE_OAUTH_QUERY_PARAM,
  AUTH_DEFAULT_GOOGLE_SCOPES,
  AUTH_FACEBOOK_OAUTH_QUERY_PARAM,
  AUTH_GOOGLE_OAUTH_QUERY_PARAM,
  AUTH_GOOGLE_REDIRECT_SCOPE,
  AuthGoogleScope,
} from "./src/auth-constants";
export * from "./src/auth-response-types";
export * from "./src/auth-request-types";
export * from "./src/AuthBrowser";
export * from "./src/AuthBase";
export * from "./src/fetchAuth";
export * from "./src/google/createGoogleScopesManager";
export * from "./src/google/fetchGoogleContacts";
export * from "./src/google/fetchGoogleDirectoryContacts";
export * from "./src/google/fetchGoogleOtherContacts";
export * from "./src/loaders/loadFacebook";
export * from "./src/loaders/loadDropbox";
export * from "./src/utils/areGoogleScopesIncluded";
export * from "./src/utils/createAuthFetchLoginInput";
export * from "./src/utils/createAuthHeaders";
export * from "./src/utils/getClientId";
export * from "./src/utils/postPremiumStripeInvoices";
export {
  grantOfflineAccess,
  getGoogleContacts,
  getGoogleTokenByGoogleLogin,
  getGoogleAuthCode,
  openGoogleDrivePicker,
  isGSuiteAccount,
  InsufficientScopeError,
} from "./src/google/google-ops";
export { getOneDriveAccessToken } from "./src/third-party/onedrive";
export { getBoxAccessToken } from "./src/third-party/box";
export * from "./src/AbService";
